<template>
  <div class="card-item">
    <template v-if="ad">
      <!-- Card image -->
      <div class="card-image">
        <div class="card-image-count">
          1 / {{ ad.numPhotos }}
        </div>

        <img
          v-show="!imageError"
          :src="ad.photo"
          :alt="ad.street_address"
          @error="imageFailed">
        <!-- If card image does not load -->
        <div
          v-show="imageError"
          style="background: url(/img/error.jpg);
    background-repeat:no-repeat;
    background-position:center center;background-size:cover;">
          <div
            style="height: 0;
  padding-top: 56.25%;
    background: url(/img/loader.svg);
    background-repeat:no-repeat;
    background-position:center center;
    "></div>
        </div>
        <!-- <img :src="'/img/loader.svg'" :alt="ad.street_address" /> -->

        <!-- <img src="img/temp-apartment.jpg" class="show-for-medium" alt="Sankt Eriksplan 2"> -->
        <!-- <img src="img/temp-apartment-mob.jpg" class="hide-for-medium" alt="Sankt Eriksplan 2"> -->
        <!-- Card tags -->
        <div
          v-if="likeorpass > 0"
          class="is-liking"
          :style="{
            backgroundColor: 'rgba(100, 188, 178, ' + likeorpassBG + ')'
          }">
          <div :style="{ opacity: likeorpassPIC }">
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24">
              <path
                fill-rule="evenodd"
                d="M23.796455 2.4492654c1.049477.8802059 1.777339 1.9635372 2.183588 3.2499922.406249 1.286455.465494 2.5813738.177734 3.8847564-.28776 1.3033825-.905596 2.4290304-1.853511 3.3769451L14.503508 23.117185c-.338541.338541-.727863.507811-1.167966.507811s-.829425-.16927-1.167966-.507811L2.366818 13.0117402C1.418904 12.0299719.801067 10.8873965.513307 9.584014.225547 8.2806314.284792 6.9857126.691041 5.6992576c.406249-1.286455 1.134112-2.3697863 2.183589-3.2499922.91406-.7786438 1.946609-1.2695283 3.097648-1.4726528 1.15104-.2031245 2.285151-.118489 3.402336.2539057s2.098953.9986958 2.945306 1.8789017l1.015622 1.0156226L14.351165 3.10942c.846352-.8802059 1.82812-1.506507 2.945305-1.8789017 1.117185-.3723947 2.251297-.4570302 3.402336-.2539057 1.151039.2031245 2.183588.694009 3.097649 1.4726528z" />
            </svg>
          </div>
        </div>

        <div
          v-if="likeorpass < 0"
          class="is-passing"
          :style="{
            backgroundColor: 'rgba(255, 119, 101, ' + likeorpassBG + ')'
          }">
          <div :style="{ opacity: likeorpassPIC }">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19">
              <path
                fill-rule="evenodd"
                d="M12.737887 9.2500232L17.816 14.3281361c.304687.3046868.45703.6770819.45703 1.1171849s-.152343.829425-.45703 1.167966l-1.117185 1.117185c-.338541.304687-.727862.45703-1.167965.45703-.440104 0-.812499-.152343-1.117185-.45703l-5.078113-5.0781131-5.078113 5.0781131c-.304687.304687-.677082.45703-1.117185.45703-.440103 0-.829425-.152343-1.167966-.45703L.855103 16.613287c-.304687-.338541-.45703-.727863-.45703-1.167966s.152343-.8124981.45703-1.1171849l5.078113-5.0781129L.855103 4.1719104c-.304687-.3046868-.45703-.6770815-.45703-1.1171849 0-.4401034.152343-.8294248.45703-1.1679659L1.972288.7695747c.338541-.3046868.727863-.4570301 1.167966-.4570301s.812498.1523433 1.117185.4570301l5.078113 5.0781129L14.413665.7695747c.304686-.3046868.677081-.4570301 1.117185-.4570301.440103 0 .829424.1523433 1.167965.4570301L17.816 1.8867596c.304687.3385411.45703.7278625.45703 1.1679659 0 .4401034-.152343.8124981-.45703 1.1171849l-5.078113 5.0781128z" />
            </svg>
          </div>
        </div>
        <div class="card-tags-wrap">
          <div class="card-tag"><span v-if="ad.floor == 0">BV</span><span v-else>Vån {{ ad.floor }}</span>
 </div>
          <div v-for="d in details.slice(0, 2)" :key="d.name" class="card-tag">
            {{ $t(d.slug) }}
          </div>
        </div>
      </div>

      <!-- Card info -->
      <div class="card-info">
        <div class="c-grid">

          <!-- location -->
            <div class="big">
              <h2>{{ ad.street }} {{ ad.street_number }}</h2>
              <h3>{{ ad.city }}</h3>
            </div>

          <!-- THE rent -->
     
            <div class="small">
              <!-- <span class="nav-icon"> -->
                <svg width="29px" height="22px" viewBox="0 0 29 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="room" transform="translate(0.150000, 1.000000)" fill="#ABABAB" fill-rule="nonzero" stroke="#ABABAB" stroke-width="0.9">
                      <path id="Shape" d="M27.85,14.5910417 L27.756852,5.48354167 L27.6363606,5.32375 L14.4300772,0 L14.3089848,0 L14.1878924,0 L0.970491448,5.324375 L0.85,5.47833333 L0.936237021,14.5895833 L1.01496211,14.6964583 L14.2491898,20 L14.4913746,20 L27.7643639,14.70125 L27.85,14.5910417 Z M27.3716399,14.2897917 L23.0805218,12.5685417 L23.2370706,5.7875 L23.1565426,5.68895833 L18.80593,3.94291667 L18.5637452,4.03791667 L18.3510072,10.6947917 L14.433683,9.14708333 L14.433683,0.467291667 L27.2156922,5.581875 L27.3716399,14.2897917 Z M22.7611143,12.4404167 L18.7290078,10.823125 L18.8819508,4.23604167 L22.9131559,5.85875 L22.7611143,12.4404167 Z M14.1332055,0.467291667 L14.1332055,9.18791667 L9.73661985,10.951875 L1.43322668,14.2858333 L1.37553502,5.58125 L14.1332055,0.467291667 Z M14.3705827,19.7070833 L1.65467854,14.59375 L2.79378846,14.1333333 L14.3393331,9.490625 L26.0699717,14.1702083 L27.1225442,14.5925 L14.3705827,19.7070833 Z M5.94669809,9.70854167 L5.71983763,9.61229167 L5.71983763,6.23270833 L5.77933216,6.13625 L10.5935815,4.16666667 L10.8279539,4.26291667 L10.8279539,7.6425 L10.7648536,7.73895833 L5.94669809,9.70854167 Z M6.02031506,6.29666667 L6.02031506,9.41708333 L10.5274764,7.57875 L10.5274764,4.45833333 L6.02031506,6.29666667 Z" />
                    </g>
                  </g>
                </svg>
              <!-- </span> -->
              <p><nobr>{{ ad.rooms }} {{ $tc('ad.rooms', ad.rooms) }}</nobr></p>
            </div>




           
           <!-- THE rent -->
            <div class="small">
              <!-- <span class="nav-icon"> -->
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20">
                  <path
                    fill-rule="evenodd"
                    d="M26.235807.1250426c.372395 0 .69466.1360676.966795.4082022.272134.2721345.408202.5943994.408202.9667945V18c0 .3723952-.136068.69466-.408202.9667946-.272135.2721345-.5944.4082021-.966795.4082021H1.485866c-.372395 0-.69466-.1360676-.966794-.4082021C.246937 18.69466.11087 18.3723952.11087 18V1.5000393c0-.3723951.136067-.69466.408202-.9667945.272134-.2721346.594399-.4082022.966794-.4082022h24.749941zm0 17.8749574V1.5000393H1.485866V18h24.749941zm-13.406218-5.4999869c-.085937 0-.164713-.035807-.236327-.1074216-.071615-.0716146-.107422-.1503903-.107422-.2363276v-.6874983c0-.0859373.035807-.164713.107422-.2363276.071614-.0716146.15039-.1074216.236327-.1074216h3.437492c.085937 0 .164713.035807.236328.1074216.071614.0716146.107421.1503903.107421.2363276v.6874983c0 .0859373-.035807.164713-.107421.2363276-.071615.0716146-.150391.1074216-.236328.1074216h-3.437492zm10.312476-1.3749967c.085937 0 .164713.035807.236327.1074216.071615.0716146.107422.1503903.107422.2363276v.6874983c0 .0859373-.035807.164713-.107422.2363276-.071614.0716146-.15039.1074216-.236327.1074216h-3.437492c-.085937 0-.164713-.035807-.236328-.1074216-.071614-.0716146-.107421-.1503903-.107421-.2363276v-.6874983c0-.0859373.035807-.164713.107421-.2363276.071615-.0716146.150391-.1074216.236328-.1074216h3.437492zM12.829589 8.3750229c-.085937 0-.164713-.0358069-.236327-.1074216-.071615-.0716146-.107422-.1503902-.107422-.2363275v-.6874984c0-.0859373.035807-.1647129.107422-.2363276.071614-.0716146.15039-.1074216.236327-.1074216h10.312476c.085937 0 .164713.035807.236327.1074216.071615.0716147.107422.1503903.107422.2363276v.6874984c0 .0859373-.035807.1647129-.107422.2363275-.071614.0716147-.15039.1074216-.236327.1074216H12.829589zM5.911637 9.835957c-.401041-.1145833-.723305-.3294266-.966795-.6445297-.243489-.3151032-.365233-.6588524-.365233-1.0312476 0-.4869778.164713-.8951799.494139-1.2246064.329427-.3294266.737629-.5084622 1.224607-.5371081v-.4296865c0-.0859373.035807-.1647129.107421-.2363276.071615-.0716146.150391-.1074216.236328-.1074216h.687498c.085938 0 .164713.035807.236328.1074216.071615.0716147.107422.1503903.107422.2363276v.4296865c.458332.0286459.859372.1718746 1.203122.4296864.085937.0572913.136067.128906.15039.2148433.014323.0859373-.021484.1718746-.107422.2578119l-.515623.5585924c-.085938.1145833-.207682.1289059-.365234.0429686s-.336587-.1289059-.537108-.1289059H6.384292c-.114583 0-.214843.035807-.30078.1074216-.085938.0716146-.128906.1647129-.128906.2792962 0 .1718746.10026.2864579.30078.3437492l1.804683.4726551c.401041.1145833.723306.3294265.966795.6445297.243489.3151032.365233.6588524.365233 1.0312476 0 .4869778-.164713.8951799-.494139 1.2246064-.329427.3294265-.737629.5084621-1.224606.5371081v.4296865c0 .0859373-.035807.1647129-.107422.2363276-.071615.0716146-.15039.1074216-.236328.1074216h-.687498c-.085937 0-.164713-.035807-.236328-.1074216-.071614-.0716147-.107421-.1503903-.107421-.2363276v-.4296865c-.458333-.028646-.859373-.1718746-1.203122-.4296865-.085938-.0572913-.136068-.1289059-.150391-.2148432-.014322-.0859373.021485-.1718746.107422-.2578119l.515624-.5585924c.085937-.1145833.207681-.1289059.365233-.0429686.157552.0859372.336588.1289059.537108.1289059h1.117185c.114584 0 .214843-.035807.300781-.1074216.085937-.0716147.128906-.164713.128906-.2792962 0-.1718746-.10026-.2864579-.300781-.3437492L5.911637 9.835957z" />
                </svg>
              <!-- </span> -->
              <p>{{ ad.rent | currency }}</p>
            </div>
  




            <div class="small">
              <!-- <span class="nav-icon"> -->
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20">
                  <path
                    fill-rule="evenodd"
                    d="M24.062443 0c.171874 0 .329426.064453.472655.1933589.143228.128906.214843.2936189.214843.4941395v14.867152c0 .2864579-.078776.5442698-.236328.7734357-.157551.2291659-.365233.4010405-.623045.5156237l-6.531234 2.2773384c-.572915.1718746-1.145831.1718746-1.718746 0L8.24998 16.4999607.94531 19.2069855c-.085937.0286459-.171874.0429686-.257812.0429686-.171874 0-.329426-.064453-.472655-.1933589C.071615 18.9276892 0 18.7629763 0 18.5624557V3.6953037c0-.2864579.078776-.5442698.236328-.7734357.157551-.2291659.365233-.4010405.623045-.5156237L7.390607.1289059C7.677065.0429686 7.963522 0 8.24998 0c.286458 0 .572915.0429686.859373.1289059l7.390608 2.6210875 7.30467-2.7070248C23.890568.0143227 23.976505 0 24.062443 0zM1.332028 3.6953037l.042969 13.8788731 6.187485-2.2773383V1.5468713L1.332028 3.6953037zm7.605451 11.6015348l6.874983 2.4062443V3.9531156L8.937479 1.5468713v13.7499672zm8.24998 2.4062443l6.230454-2.1484324-.042969-13.8788731-6.187485 2.2773383v13.7499672z" />
                </svg>
              <!-- </span> -->
              <p><nobr>{{ ad.size }} m<sup>2</sup></nobr></p>
            </div>
          </div>
      </div>
      <!-- /Card info -->
      <!-- <div class="card" style="height:100%;">
      <img :src="ad.photo" style="width:100%;" />
      <div class="card-section">
        <p>{{ ad.rooms }} rum {{ ad.size }} m<sup>2</sup></p>
        <p>{{ ad.rent | currency }}/mån</p>
        <span v-for="d in ad.details" :key="d" class="label">{{
          adExtras[d]
        }}</span>

      </div>
      </div>-->
    </template>
  </div>
</template>

<script>
// import { adExtras } from '@/services/AdService.js'

export const adExtras = {
  0: { name: 'ERROR', slug: 'ad.ERROR', value: 5 },
  1: { name: 'Bredband', slug: 'ad.broadband', value: 0 },
  2: { name: 'Kabel-TV', slug: 'ad.cable', value: 0 },
  3: { name: 'Hiss', slug: 'ad.elevator', value: 3 },
  4: { name: 'Öppen spis', slug: 'ad.openfire', value: 4 },
  5: { name: 'Badkar', slug: 'ad.bathtub', value: 0 },
  6: { name: 'Dusch', slug: 'ad.shower', value: 0 },
  7: { name: 'Förråd', slug: 'ad.storage', value: 0 },
  8: { name: 'Balkong/Terrass', slug: 'ad.balconyterrace', value: 5 },
  9: { name: 'Balkong', slug: 'ad.balcony', value: 5 },
  10: { name: 'Terrass', slug: 'ad.terrace', value: 5 },
  11: { name: 'Kakelugn', slug: 'ad.tiledstove', value: 5 }
}

export default {
  filters: {},
  props: {
    likeorpass: {
      type: Number,
      default: 0
    },
    ad: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imageError: false,
      adExtras
    }
  },
  computed: {
    likeorpassPIC() {
      return Math.abs(this.likeorpass)
    },
    likeorpassBG() {
      // return  this.likeorpass > 0.5 ? 0.5
      let likeorpass = 0
      if (Math.abs(this.likeorpass) > 0.5) {
        likeorpass = 0.5
      } else {
        likeorpass = this.likeorpass
      }
      return Math.abs(likeorpass)
    },
    translatedDetails() {
      return adExtras // lang: this.$t('ad.own')
    },
    details() {
      if (!this.ad.details.length) {
        return []
      }
      let details = this.ad.details
        .map(x => ({
          name: this.translatedDetails[x].name,
          value: this.translatedDetails[x].value,
          slug: this.translatedDetails[x].slug
        }))
        .sort(function(obj1, obj2) {
          // Ascending: first age less than the previous
          return obj1.value - obj2.value
        })
        .filter(x => x.value != 0)

      // details.sort((a, b) => a.value.localeCompare(b.value))
      // details.sort((a, b) => a.value > b.value)
      // return details.reverse()
      // details.sort().reverse()
      // return details
      //   .sort(function(obj1, obj2) {
      //     // Ascending: first age less than the previous
      //     return obj1.value - obj2.value
      //   })
      //   .reverse()
      return details
    }
  },
  methods: {
    imageFailed() {
      // console.log('Det blev ett fel!')
      this.imageError = true
      this.$emit('imageFailed')
    }
  }
}
</script>

<style lang="scss" scoped>

.c-grid{
  display:grid;
  // grid-template-columns: repeat( auto-fit, minmax(25px, 1fr) );
  // place-items: center;
  // justify-items: center stretch;
  // grid-template-rows: 1fr 1fr;
// grid-template-columns: auto repeat(3, min-content);
  // grid-auto-columns: 1fr;
// grid-template-columns: max-content repeat(3, min-content)
grid-template-columns:  repeat(fit-content, minmax(min-content, 1fr))
// grid-auto-rows: min-content;

}

.c-grid div{
  // border:1px solid red;
  border: 1px solid #f6f7f9;
  // padding:10px;
}

.c-grid .big{
  color:#121212;  
  padding:8px 20px;
  // grid-column:1/-1;
  // grid-row:1;

  grid-column: 1 / span 3;
  grid-row:1;
  ;

}

.c-grid .big h3{
    font-size: 14px;
    font-weight: 600;
    color: #ababab;
   
    }


    
.c-grid .big h2{
   font-size: 16px;
    font-weight: 700;
    color: #121212;
   white-space:nowrap;
    overflow: hidden;
  
    }



.c-grid .small{
  color:#666;
  display:grid;
  // grid-row:2
  
  grid-row:1;
    font-size:0.8em;

place-content: center;
    align-content: space-evenly;
    justify-items: center;
}

.c-grid .small:last-of-type{
// color:red;
// padding-right:8px;
border-right:0;;
}

.big h2{
    font-size:1em;
    color:red;

}

.c-grid .small svg{
  fill: #ababab;
}
</style>
